export interface UserProfile {
    createdByUsername?: string;
    createdBy?: {
        givenName: string;
        familyName: string;
    };
    createdByUser?: {
        name: string;
        givenName: string;
        familyName: string;
        email: string;
    };
    [key: string]: unknown;
}

export const CreatedByProfileFormatter = ({record}: { record: UserProfile }): string => {

    const {
        createdByUsername,
        createdBy,
        createdByUser
    } = record;


    if (!createdByUsername) {
        throw new Error('createdByUsername is required');
    }

    // Priority 1: Use createdByUser name if available
    if (createdByUser?.name) {
        return createdByUser.name;
    }

    // Priority 2: Use createdByUser givenName + familyName if available
    if (createdByUser?.givenName && createdByUser?.familyName) {
        const formattedGivenName = createdByUser.givenName.trim();
        const formattedFamilyName = createdByUser.familyName.trim();

        if (formattedGivenName && formattedFamilyName) {
            return `${formattedGivenName} ${formattedFamilyName}`;
        }
    }

    // Priority 3: Use createdBy name if available
    if (createdBy?.givenName && createdBy?.familyName) {
        const formattedGivenName = createdBy.givenName.trim();
        const formattedFamilyName = createdBy.familyName.trim();

        if (formattedGivenName && formattedFamilyName) {
            return `${formattedGivenName} ${formattedFamilyName}`;
        }
    }

    // Priority 4: Fallback to createdByUsername
    return createdByUsername;
};
